import React from 'react';
import Grid from '@mui/material/Grid';
//import { useParams, useRouteMatch } from "react-router-dom";

export default function Loading() {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ maxHeight: '20px' }}
      >
        <img src={process.env.PUBLIC_URL + '/assets/dots.gif'} alt="Loading .." style={{ maxHeight: '20px' }}/>
      </Grid>
    );
}
